import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-12 px-6 bg-[#0f0f23]" data-id="element-63">
      <div className="bg-gradient-to-b from-slate-800/50 to-slate-900/50 border border-slate-700 rounded-2xl p-8 text-center relative overflow-hidden" data-id="element-64">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-32 h-32 bg-blue-500/10 rounded-full blur-2xl" data-id="element-65" />

        <div className="relative z-10" data-id="element-66">
          <div className="inline-flex items-center justify-center p-4 bg-blue-500/10 rounded-full mb-6" data-id="element-67">
            <ShieldCheck className="w-12 h-12 text-blue-400" data-id="element-68" />
          </div>

          <h2 className="text-2xl font-black text-white mb-4" data-id="element-69">
            Tenés 7 días de garantía total
          </h2>

          <p className="text-gray-300 text-sm leading-relaxed mb-6" data-id="element-70">
            Si el sistema no es lo que esperabas o no se adapta a tu forma de
            trabajar:
            <br data-id="element-71" />
            <span className="font-bold text-white mt-2 block" data-id="element-72">
              Te devolvemos el dinero
            </span>
          </p>

          <p className="text-gray-500 text-xs font-medium uppercase tracking-widest" data-id="element-73">
            Sin preguntas.
          </p>
        </div>
      </div>
    </section>;
}